import React from 'react';

class Chatbot extends React.Component {
  componentDidMount(){
    document.title = document.title = window.cc.companyInfo.service + " Service";
  }
  UNSAFE_componentWillMount(){
    document.getElementById('body').className='content_page';
  }
  render(props){
    return (
        <div className="content_testo tab-content">
					<div id="content-core">
						<div className="row" style={{alignItems: "center", height: "calc(100vh - var(--header-height) - var(--footer-height))"}}>
							<div className="col-xl-12" style={{height: "100%"}}>
              <iframe title="chatbot" src="https://sym.chatbot-swan.softway.it/" style={{width: "100%", height: "100%", border: "none"}}></iframe>
 							</div>
						</div>
					</div>
        </div>
    )
  }
}

export default Chatbot;
